import { Component, OnInit, Input } from '@angular/core';
import { environment as params } from 'src/environments/environment';
import { GeneralWPService } from 'src/app/core/http/web/generalWp.service';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  // public generalData: any;
  urlBaseS3: any = (<any>params).api.s3;
  public dataMenu: any;
  public dataMenuEscr: any;
  public dataMenuMobil: any;
  public dataSubMenu: any;
  public logo:string=''
  @Input('loadServ') public loadServ: boolean = true;
  @Input('data') public generalData: any;
  constructor(
    private gWPServ: GeneralWPService,
    private router: Router
  ) {
    if (this.loadServ) {
      this.getGeneralOptions();
    }
    this.getDataMenu();
  }

  ngOnInit() {
  }

  getGeneralOptions() {
    this.gWPServ.getGeneralOptions().subscribe(
      data => {
        this.generalData = data.data;
        this.logo=this.urlBaseS3 + data.data.logo.url
        if (!(data.data && data.data.length > 0)) {
          console.warn('Sin data general');
        }
      },
      err => {
        console.error(err);
      }
    );
  }
  getDataMenu() {
    this.gWPServ.getDataMenuSuperior().subscribe(
      data => {
        this.dataMenu = data.menusuperior.menu;
        this.dataMenuEscr = this.dataMenu.filter(f => f.aparicion !== '2');
        this.dataMenuMobil = this.dataMenu.filter(f => f.aparicion !== '1');

        for (let i = 0; i < this.dataMenuEscr.length; i++) {
          if (this.dataMenuEscr[i].menu_interior.length > 0) {
            for (let x = 0; x < this.dataMenuEscr[i].menu_interior.length; x++) {
              if (this.dataMenuEscr[i].menu_interior[x].linkinterior != '' && this.dataMenuEscr[i].menu_interior[x].linkexterior != '') {
                this.dataMenuEscr[i].menu_interior[x].linkinterior = this.dataMenuEscr[i].menu_interior[x].linkexterior;
              } else if (this.dataMenuEscr[i].menu_interior[x].linkinterior == '' && this.dataMenuEscr[i].menu_interior[x].linkexterior != '') {
                this.dataMenuEscr[i].menu_interior[x].linkinterior = this.dataMenuEscr[i].menu_interior[x].linkexterior;
              }
            }
          }
        }
      },
      err => {
        console.error(err);
      }
    );
  }
  closeMenuMobile() {
    $('#mobile-submenu').modal('hide');
    $('#mobile-menu-modal').modal('hide');
  }
  showModalSubmenu(id) {
    this.dataSubMenu = this.dataMenu.find(f => f['isintrep-menuinterior'] === id);
  }
  redirectTo(url: string) {
    this.closeMenuMobile();
    this.router.navigate([url]);
  }

  url(urlBaseS3:string, logo:any){
    return urlBaseS3 + logo.url

  }
}
